<!-- src/components/layout/BottomNav.vue -->
<!-- Mobile-only bottom navigation bar -->
<template>
  <nav
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-[var(--border)] md:hidden z-40 safe-area-bottom"
  >
    <div class="flex items-center justify-around h-16">
      <RouterLink
        v-for="item in navItems"
        :key="item.path"
        :to="item.path"
        class="flex flex-col items-center justify-center flex-1 h-full transition-colors"
        :class="isActive(item.path) ? 'text-[var(--primary-600)]' : 'text-[var(--text-tertiary)]'"
      >
        <font-awesome-icon :icon="item.icon" class="text-xl mb-1" />
        <span class="text-xs font-medium">{{ item.label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/AuthStore'

const route = useRoute()
const auth = useAuthStore()

const allNavItems = [
  { label: 'Today', path: '/today', icon: ['fas', 'house'], teacherOnly: true },
  { label: 'Classes', path: '/classes', icon: ['fas', 'book-open'], teacherOnly: true },
  { label: 'Planning', path: '/planning', icon: ['fas', 'clipboard-list'], teacherOnly: true },
  { label: 'Connect', path: '/connect', icon: ['fas', 'comments'], teacherOnly: false },
  { label: 'Schedule', path: '/schedule', icon: ['fas', 'calendar-week'], teacherOnly: false },
  { label: 'Settings', path: '/settings', icon: ['fas', 'gear'], teacherOnly: true },
  { label: 'Account', path: '/account', icon: ['fas', 'user'], studentOnly: true, teacherOnly: false },
]

const navItems = computed(() => {
  if (auth.isStudent) {
    return allNavItems.filter((item) => !item.teacherOnly)
  }
  return allNavItems.filter((item) => !('studentOnly' in item && item.studentOnly))
})

function isActive(path: string): boolean {
  if (path === '/today') {
    return route.path === '/today' || route.path === '/home'
  }
  return route.path.startsWith(path)
}
</script>

<style scoped>
/* Handle safe area for devices with home indicators (iPhone X+) */
.safe-area-bottom {
  padding-bottom: env(safe-area-inset-bottom, 0);
}
</style>
